import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ApiService} from '@app/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class ConsultingService {

  constructor(private api: ApiService) {
  }

  medicine_search(term = "") {
    if (term.length > 2) {
      return this.api.post("Medicine/listMedicine", {
        search_text: term,
        limit: 10,
        medicine_id: '0',
        start: 0
      })
    } else {
      return of([]);
    }
  }

  medicine_purchase_search(term = '', vendor_id: any) {
    if (term.length > 2) {
      return this.api
        .post("PurchaseReturn/listMedicine", {
          search_text: term,
          limit: 10,
          vendor_id: vendor_id,
          start: 0
        });
    } else {
      return of([]);
    }
  }

  medicine_sale_search(term: string, sale_id: any) {
    if (term == '') {
      return of([]);
    }
    if (term.length > 2) {
      return this.api.post("SaleReturn/listMedicine", {earch_text: term, limit: 10, sale_id: sale_id, start: 0});
    } else {
      return of([]);
    }
  }

  saveMedicine(params: any): Observable<any> {
    return this.api.post('Medicine/saveMedicine', params);
  }

  saveVendor(params: any): Observable<any> {
    return this.api.post('Vendor/saveVendor', params);
  }

  saveCustomer(params: any): Observable<any> {
    return this.api.post('Customer/saveCustomer', params);
  }

  listCustomer(params: any): Observable<any> {
    return this.api.post('Customer/listCustomer', params);
  }
  listCustomerInvoices(postData: any): Observable<any> {
    return this.api.post('Sale/listCustomerInvoices', postData);
  }
  getCustomerSOA(postData: any): Observable<any> {
    return this.api.post('Statement/getCustomerSOA', postData);
  }
  getSupplierSOA(postData: any): Observable<any> {
    return this.api.post('StatementPayment/getSupplierSOA', postData);
  }
  listVendor(params: any): Observable<any> {
    return this.api.post('Vendor/listVendor', params);
  }

  listWarehouse(params: any): Observable<any> {
    return this.api.post('Warehouse/listWarehouse', params);
  }

  Vendors(params: any): Observable<any> {
    return this.api.post('Vendor/Vendors', params);
  }

  listPurchaseVendor(params: any): Observable<any> {
    return this.api.post('PurchaseReturn/listVendor', params);
  }

  listPurchaseItems(params: any): Observable<any> {
    return this.api.post('Purchase/listPurchaseItems', params);
  }

  listPurchaseItemsByVendor(params: any): Observable<any> {
    return this.api.post('Purchase/listPurchaseItemsByVendor', params);
  }

  saveSlabDetails(params: any): Observable<any> {
    return this.api.post('Purchase/saveSlabDetails', params);
  }

  listPurchaseInvoice(): Observable<any> {
    return this.api.post('Purchase/listPurchaseInvoice');
  }

  listProductDetails(params: any): Observable<any> {
    return this.api.post('PurchaseReturn/listProductDetails', params);
  }

  warehouselist(postdata: any): Observable<any> {
    return this.api.post('Sale/WarehouseList', postdata);
  }

  getVendor(params: any): Observable<any> {
    return this.api.post('Vendor/getVendor', params);
  }

  getCustomer(params: any): Observable<any> {
    return this.api.post('Customer/getCustomer', params);
  }

  saveNotes(params: any): Observable<any> {
    return this.api.post('Notes/saveNotes', params);
  }

  listNotes(params: any): Observable<any> {
    return this.api.post('Notes/listNotes', params);
  }

  getSlab(params: any): Observable<any> {
    return this.api.post('ComboProduct/getSlab', params);
  }

  listMedicine(params: any): Observable<any> {
    return this.api.post('Medicine/listMedicine', params);
  }

  listOrderMedicine(params: any): Observable<any> {
    return this.api.post('Purchase/listMedicine', params);
  }

  getMedicine(params: any): Observable<any> {
    return this.api.post('Medicine/getMedicine', params);
  }

  listUnit(params: any): Observable<any> {
    return this.api.post('Medicine/listUnit', params);
  }

  listCategory(): Observable<any> {
    return this.api.post('Medicine/listCategory', null);
  }

  saveUnit(params: any): Observable<any> {
    return this.api.post('Medicine/saveUnit', params);
  }

  saveReturnPurchase(params: any): Observable<any> {
    return this.api.post('PurchaseReturn/saveReturnPurchase', params);
  }

  savePurchaseDeatils(params: any): Observable<any> {
    return this.api.post('Purchase/savePurchaseDetails', params);
  }

  saveComboProduct(params: any): Observable<any> {
    return this.api.post('ComboProduct/saveComboProduct', params);
  }

  getPurchase(params: any): Observable<any> {
    return this.api.post('Purchase/getPurchase', params);
  }

  getReturnPurchase(params: any): Observable<any> {
    return this.api.post('PurchaseReturn/getReturnPurchase', params);
  }

  listReturnPurchase(params: any): Observable<any> {
    return this.api.post('PurchaseReturn/listReturnPurchase', params);
  }

  generateBarcode(params: any): Observable<any> {
    return this.api.post('Purchase/generateBarcode', params);
  }

  saveVATCredit(params: any): Observable<any> {
    return this.api.post('Purchase/saveVATCredit', params);
  }

  savepaymentCredit(params: any): Observable<any> {
    return this.api.post('Sale/savepaymentCredit', params);
  }

  PurchaseFinalize(params: any): Observable<any> {
    return this.api.post('Purchase/PurchaseFinalize', params);
  }

  listPurchase(params: any): Observable<any> {
    return this.api.post('Purchase/listPurchase', params);
  }

  listSupplierPrice(params: any): Observable<any> {
    return this.api.post('SupplierPrice/listSupplierPrice', params);
  }

  listaddSupplierPrice(): Observable<any> {
    return this.api.post('SupplierPrice/listaddSupplierPrice', null);
  }

  deleteSupplierPrice(params: any): Observable<any> {
    return this.api.post('SupplierPrice/deleteSupplierPrice', params);
  }

  ClearAddRateSheet(): Observable<any> {
    return this.api.post('SupplierPrice/ClearAddRateSheet', null);
  }

  deleteaddSupplierPrice(params: any): Observable<any> {
    return this.api.post('SupplierPrice/deleteaddSupplierPrice', params);
  }

  addSupplierlist(params: any): Observable<any> {
    return this.api.post('SupplierPrice/addSupplierlist', params);
  }

  listInvoiceNo(params: any): Observable<any> {
    return this.api.post('PurchaseReturn/listInvoiceNo', params);
  }

  createPurchaseOrder(params: any): Observable<any> {
    return this.api.post('SupplierPrice/createPurchaseOrder', params);
  }

  listStockReport(params: any): Observable<any> {
    return this.api.post('Report/listStockReport', params);
  }

  listAllItems(): Observable<any> {
    return this.api.post('Report/listAllItems', null);
  }

  saveAddPrice(params: any): Observable<any> {
    return this.api.post('ComboProduct/saveAddPrice', params);
  }

  listCostSheet(params: any): Observable<any> {
    return this.api.post('Report/listCostSheet', params);
  }

  listAgent(params: any): Observable<any> {
    return this.api.post('Report/listAgent', params);
  }

  listVatReport(params: any): Observable<any> {
    return this.api.post('VatReport/listVatReport', params);
  }

  listVatsaleReport(params: any): Observable<any> {
    return this.api.post('VatReport/listVatsaleReport', params);
  }

  listVatPurchaseReport(params: any): Observable<any> {
    return this.api.post('VatReport/listVatPurchaseReport', params);
  }

  getSales(params: any): Observable<any> {
    return this.api.post('Report/getSales', params);
  }

  listHsnReport(params: any): Observable<any> {
    return this.api.post('VatReport/listHsnReport', params);
  }

  listTaxReport(params: any): Observable<any> {
    return this.api.post('VatReport/listTaxReport', params);
  }

  savePayment(params: any): Observable<any> {
    return this.api.post('Payment/savePayment', params);
  }
  saveReceipt(params: any): Observable<any> {
    return this.api.post('Receipt/saveReceipt', params);
  }

  getPaymentNo(): Observable<any> {
    return this.api.post('Payment/getPaymentNo');
  }

  getPaymentList(): Observable<any> {
    return this.api.post('Payment/getPaymentList');
  }
  getReceiptNo(): Observable<any> {
    return this.api.post('Receipt/getReceiptNo');
  }

  getReceiptList(): Observable<any> {
    return this.api.post('Receipt/getReceiptList');
  }
  deletePayment(params: any): Observable<any> {
    return this.api.post('Payment/deletePayment', params);
  }
  listVendorPurchaseInvoices(params: any): Observable<any> {
        return this.api.post('Payment/listVendorPurchaseInvoices', params);
  }
  deleteMedicineItem(params: any): Observable<any> {
    return this.api.post('Medicine/deleteMedicineItem', params);
  }
  deleteVendor(params: any): Observable<any> {
    return this.api.post('Vendor/deleteVendor', params);
  }
  deleteCustomer(params: any): Observable<any> {
    return this.api.post('Customer/deleteCustomer', params);
  }
}


